const DietPackagingAssignmentItemComponent = (
	json: IDietPackagingAssignmentItemComponent,
): IDietPackagingAssignmentItemComponentModel => {
	const { name, type, group_id, group_name, updated_at, created_at, ...rest } = json

	const _group = group_id && group_name ? { id: group_id, name: group_name } : null

	return {
		...rest,
		type: type ?? null,
		name: name ? LangContentToModel(name) : { pl: group_name ?? '' },
		group: _group,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

const DietPackagingAssignmentItem = (json: IDietPackagingAssignmentItem): IDietPackagingAssignmentItemModel => {
	const { model, model_id, model_type, updated_at, created_at, ...rest } = json

	return {
		...rest,
		model: model ? DietPackagingAssignmentItemComponent(model) : null,
		modelId: model_id,
		modelType: model_type,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

const DietPackagingAssignmentType = (json: IDietPackagingAssignmentType): IDietPackagingAssignmentTypeModel => {
	const { name, meal_kind, compartments_qty, ...rest } = json

	return {
		...rest,
		name: LangContentToModel(name),
		mealKind: meal_kind,
		compartmentsQty: compartments_qty,
	}
}

export const DietPackagingAssignment = (json: IDietPackagingAssignment): IDietPackagingAssignmentModel => {
	const {
		meal_packaging_type_id,
		items,
		packaging_type,
		can_produce_separately,
		is_salad,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		canProduceSeparately: can_produce_separately,
		isSalad: is_salad,
		items: items ? items.map(DietPackagingAssignmentItem) : [],
		packagingType: DietPackagingAssignmentType(packaging_type),
		mealPackagingTypeId: meal_packaging_type_id,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

const DietPackagingItemToPayload = (model: IDietPackagingStepForm): IDietPackagingItemPayload | undefined => {
	const { type, order, component, compartment, weight, description } = model

	if (!component || !type || !compartment) return

	const _type = component.groupId ? EDietSharedComponentType.GROUP : type

	return {
		order,
		compartment,
		id: component.value,
		type: _type,
		weight: weight ?? null,
		description: description ?? null,
	}
}

export const DietPackagingToPayload = (
	model: IDietPackagingForm,
	components?: IDietSharedMealComponentPayload[],
): IDietPackagingPayload | undefined => {
	const { id, type, size, steps, canProduceSeparately, isSalad, gases } = model

	if (!type || !size) return

	let weight = 0
	if (components && components.length > 0) {
		weight = steps.reduce((acc, step) => {
			if (!step.component) return acc

			const component = components.find(c => c.id === step.component?.value && c.type === step.component?.type)

			if (!component) return acc

			const componentWeight = Number.isNaN(Number(component.weight_after_processing))
				? 0
				: Number(component.weight_after_processing)

			return acc + componentWeight
		}, 0)
	} else {
		weight = steps.reduce((acc, step) => {
			if (!step.weight) return acc

			const stepWeight = Number.isNaN(Number(step.weight)) ? 0 : Number(step.weight)

			return acc + stepWeight
		}, 0)
	}

	const oxygen = gases.oxygen && !Number.isNaN(Number(gases.oxygen)) ? Number(gases.oxygen) : null

	return {
		weight,
		oxygen,
		id: id ?? undefined,
		packaging_type_id: size,
		can_produce_separately: canProduceSeparately,
		is_salad: isSalad,
		items: steps.map(DietPackagingItemToPayload).filter(item => item !== undefined),
	}
}
